/* eslint-disable */
import { useState, useCallback, useEffect, useRef, FC } from 'react';
import * as MapGL from 'react-map-gl';
import { zonesLayers } from './layerStyles';
import { useMemo } from 'react';
import { Area, Zone } from '@/models/location';
import { Placeholder } from './Placeholder';
import { MAPBOX_TOKEN } from '@/features/map/constants';
import { useGeoJson } from '@/features/map';

type Props = {
  selectedZones: number[];
  area: Area | null;
  height?: string;
  width?: string;
  zones?: Zone[];
};

export const MapWithPreview: FC<Props> = ({
  zones,
  area,
  height = '400px',
  width = '100%',
  selectedZones,
}) => {
  const { geojson } = useGeoJson({ zones, disabled: true });
  const [loaded, setLoaded] = useState(false);

  const filterSelected = useMemo(() => {
    return [
      'all',
      ['in', 'id', ...selectedZones], // Ensure selected is an array of valid values
    ];
  }, [selectedZones]);

  const mapRef = useRef<MapGL.MapRef>(null);

  const setLocation = useCallback(
    ({ longitude, latitude }: { longitude: number; latitude: number }) => {
      mapRef.current?.flyTo({
        center: [longitude, latitude],
        duration: 2000,
        zoom: 9,
      });
    },
    []
  );

  useEffect(() => {
    if (area && loaded) {
      const { longitude, latitude } = area;
      setLocation({ longitude, latitude });
    }
  }, [area, loaded]);

  return (
    <div className="relative rounded-md overflow-hidden">
      <Placeholder hidden={loaded} />
      <MapGL.Map
        ref={mapRef}
        style={{ width, height }}
        mapboxAccessToken={MAPBOX_TOKEN}
        mapStyle="mapbox://styles/mapbox/light-v9"
        onLoad={() => setLoaded(true)}
        scrollZoom={false}
        interactiveLayerIds={['zones-fill', 'zones-fill-selected']}
        initialViewState={{
          longitude: 11.582423085886072,
          latitude: 50.0535131370207,
          zoom: 3,
        }}
      >
        <MapGL.NavigationControl
          style={{
            right: 10,
            top: 10,
          }}
        />
        {geojson && geojson.features.length > 0 && (
          <MapGL.Source id="zones" type="geojson" data={geojson}>
            <MapGL.Layer
              id="zones-fill"
              type="fill"
              source="zones"
              paint={zonesLayers.fill.default}
            />
            <MapGL.Layer
              id="zones-fill-selected"
              type="fill"
              source="zones"
              paint={zonesLayers.fill.selected}
              filter={filterSelected}
            />
            <MapGL.Layer
              id="zones-outline"
              type="line"
              source="zones"
              paint={zonesLayers.outline.default}
            />
            <MapGL.Layer
              id="zones-outline-selected"
              type="line"
              source="zones"
              paint={zonesLayers.outline.selected}
              filter={filterSelected}
            />
          </MapGL.Source>
        )}
      </MapGL.Map>
    </div>
  );
};
